import { Controller } from "@hotwired/stimulus"

// A <details> that starts open, except on a phone, where it starts folded
// (the figures index's facets).
export default class extends Controller {
  connect() {
    if (window.matchMedia("(max-width: 760px)").matches) this.element.open = false
  }
}
